export enum LOCALE {
    EN_GB = 'en-GB',
    EN_CA = 'en-CA',
    EN_AU = 'en-AU',
    EN_US = 'en-US',
    FR_FR = 'fr-FR',
    FR_CA = 'fr-CA',
    ES_ES = 'es-ES',
    ES_MX = 'es-MX',
    PT_PT = 'pt-PT',
    PT_BR = 'pt-BR',
    ZH_CN = 'zh-CN',
    ZH_TW = 'zh-TW',
    NB_NO = 'nb-NO',
    DA_DK = 'da-DK',
    DE_DE = 'de-DE',
    FI_FI = 'fi-FI',
    HU_HU = 'hu-HU',
    IT_IT = 'it-IT',
    NL_NL = 'nl-NL',
    PL_PL = 'pl-PL',
    RU_RU = 'ru-RU',
    SV_SE = 'sv-SE',
    TR_TR = 'tr-TR',
    UK_UA = 'uk-UA',
    AR_AE = 'ar-AE',
    JA_JP = 'ja-JP',
    KO_KR = 'ko-KR',
    TH_TH = 'th-TH',
    CS_CZ = 'cs-CZ',
    NN_NO = 'nn-NO'
}

/** Locale order for operations like "Text Export" */
export const LOCALE_ORDER: { readonly [locale: string]: number } = [
    LOCALE.EN_GB, LOCALE.EN_US, LOCALE.EN_CA, LOCALE.EN_AU, LOCALE.FR_FR, LOCALE.FR_CA, LOCALE.ES_ES,
    LOCALE.ES_MX, LOCALE.PT_PT, LOCALE.PT_BR, LOCALE.DE_DE, LOCALE.IT_IT, LOCALE.NL_NL, LOCALE.PL_PL,
    LOCALE.RU_RU, LOCALE.CS_CZ, LOCALE.HU_HU, LOCALE.DA_DK, LOCALE.SV_SE, LOCALE.FI_FI, LOCALE.NB_NO,
    LOCALE.NN_NO, LOCALE.TR_TR, LOCALE.UK_UA, LOCALE.JA_JP, LOCALE.KO_KR, LOCALE.ZH_CN, LOCALE.ZH_TW,
    LOCALE.TH_TH, LOCALE.AR_AE
].reduce((result: object, locale: LOCALE, index: number): object => ({ ...result, [locale]: index }), {});

/** Sort output of operations like "Text Export" based on "Text Import" spec */
export const sortLocalesByOrder = (locales: LOCALE[]): LOCALE[] => {
    const byOrder = (a: LOCALE, b: LOCALE): number => {
        return LOCALE_ORDER[a] - LOCALE_ORDER[b];
    };

    return locales.sort(byOrder);
};
